var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useRef, useState } from 'react';
import ResizeObserver from 'resize-observer-polyfill';
import styled from 'styled-components';
import { Box, CircularProgress, LinearProgress, Typography } from '@material-ui/core';
import { TraceBoardProvider, useTraceBoardContext } from './TraceBoardContext';
import TraceBoardEmptyState from './TraceBoardEmptyState';
import TraceBoardHeader from './TraceBoardHeader';
import TraceBoardRow from './TraceBoardRow';
const StyledDiv = styled.div `
  position: relative;
  display: flex;
  flex-direction: column;
  .progress-container {
    position: relative;
  }
  .progress {
    top: 0;
    width: 100%;
    position: absolute;
  }
  .board-body {
    width: 100%;
  }
  // handle overflow when browser is smaller then total min column width
  &.overflow {
    overflow: auto;
    .board-header {
      width: fit-content;
      .column-header {
        width: 320px;
      }
    }
    .board-row {
      width: fit-content;
      .board-column {
        width: 320px;
      }
    }
  }
  .row-heading {
    display: block;
    margin: 16px 12px -12px 12px;
  }
`;
export const TraceBoard = props => {
    const { rows, columns, setItems } = props, boardProps = __rest(props, ["rows", "columns", "setItems"]);
    return (React.createElement(TraceBoardProvider, { rows: rows, columns: columns, setItems: setItems },
        React.createElement(TraceBoardRoot, Object.assign({}, boardProps))));
};
export const TraceBoardRoot = props => {
    const { className, isLoading, containerProps } = props;
    const { rows, columns } = useTraceBoardContext();
    const [overflow, setOverflow] = useState(false);
    const elementRef = useRef(null);
    const observerRef = useRef(new ResizeObserver(() => {
        // check if overflow scrolling needed
        const element = elementRef.current;
        const columnMinWidth = 320;
        setOverflow(!!(element && element.clientWidth < columns.length * columnMinWidth));
    }));
    const classes = ['trace-board'];
    className && classes.push(className);
    overflow && classes.push('overflow');
    const isEmpty = rows.length === 0 || rows.every(row => row.items.length === 0);
    useEffect(() => {
        const observer = observerRef.current;
        const element = elementRef.current;
        element && observer.observe(element);
        return () => {
            element && observer.unobserve(element);
        };
    }, []);
    return (React.createElement(StyledDiv, Object.assign({}, containerProps, { ref: elementRef, className: classes.join(' ') }),
        React.createElement(TraceBoardHeader, null),
        isLoading && !isEmpty && (React.createElement("div", { className: 'progress-container' },
            React.createElement(LinearProgress, { className: 'progress' }))),
        isLoading && isEmpty ? (React.createElement(Box, { mx: 2, my: 3, display: 'flex', alignItems: 'center', flexDirection: 'column' },
            React.createElement(CircularProgress, { color: 'primary' }),
            React.createElement(Box, { mt: 2 },
                React.createElement(Typography, { variant: 'body1', className: 'text' }, "Loading Board...")))) : isEmpty ? (React.createElement(TraceBoardEmptyState, null)) : (React.createElement("div", { className: 'board-body' }, rows.map((row, index) => (React.createElement(TraceBoardRow, { row: row, key: index, rowIndex: index })))))));
};
export default TraceBoard;
//# sourceMappingURL=TraceBoard.js.map